import React, { useEffect, useState } from "react";
import { Button, Col, Row, Steps } from "antd";
import { Link, withRouter } from "react-router-dom";
import Loading from "../../../components/Generals/Loading";
import useAuth from "../../../hooks/useAuth";
import LinksOrg from "../../../components/User/Public/LinksOrg";
import { ReactComponent as LogoCaptura } from "../../../assets/img/Portal/capturaSolicitud.svg";
import { ReactComponent as LogoRevision } from "../../../assets/img/Portal/revisionSolicitud.svg";
import { ReactComponent as Observaciones } from "../../../assets/img/Portal/observacionesSolicitud.svg";
import { ReactComponent as SolValidada } from "../../../assets/img/Portal/solVerificada_img.svg";
import { ReactComponent as LogoContamos } from "../../../assets/img/Portal/declina_img.svg";
import { ESTATUS_CON_OBSERVACIONES, ESTATUS_OBSERVACIONES_ATENDIDAS, ESTATUS_SIN_REVISION, ESTATUS_VALIDADO, MSJ_ALTA_ORG, MSJ_ORG_INACTIVA, MSJ_ORG_VALIDADA, MSJ_REV_ORG, MSJ_REV_ORG_ATENDIDAS, MSJ_REV_ORG_CON_OBS } from "../../../utils/constanst";
import PregFrecOrg from "../../../components/User/Public/PregFrecOrg";
import { getDatosHomeOrg } from "../../../api/organitation";

function HomeOrg(props) {
  const { Step } = Steps;
  const [loading, setLoading] = useState(true);
  const {ciudadano: { ciudadano }, } = useAuth();
  const [estadoHomeOrg, setEstadoHomeOrg] = useState({fase: 0, mensaje: 0});
  const [datosOrg, setDatosOrg] = useState();

  useEffect(() => {
    if (ciudadano !== null) {
      window.scrollTo(0, 0); // para posicionar el scroll al inicio
      getDatosHomeOrg(ciudadano.sub).then((res) => {
        if(res.data.estatus === null) { //No hay organización registrada 
          setEstadoHomeOrg({fase: 0, mensaje: 0});
        } else {
          setDatosOrg(res.data);
          if(res.data.estatus === 1) { //Organización activa
            switch(res.data.idEstatus) {
              case ESTATUS_SIN_REVISION:
                setEstadoHomeOrg({fase: 1, mensaje: 1});
                break;
              case ESTATUS_CON_OBSERVACIONES:
                setEstadoHomeOrg({fase: 1, mensaje: 2});
                break;
              case ESTATUS_OBSERVACIONES_ATENDIDAS:
                setEstadoHomeOrg({fase: 1, mensaje: 3});
                break;
              case ESTATUS_VALIDADO:
                setEstadoHomeOrg({fase: 2, mensaje: 4});
                break;
              default:
                break;
            }
          } else { //Organización inactiva
            setEstadoHomeOrg({fase: -1, mensaje: 5});
          }
        }
        setLoading(false);
      }).catch((error) => {
        console.log("Error inesperado ", error);
        setDatosOrg(null);
        setLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Loading mientras carga la información
  if (loading) {
    return <Loading />;
  }

  const RenderMensaje = () => {
    switch (estadoHomeOrg.mensaje) {
      case MSJ_ALTA_ORG:
        return <AltaOrg />;
      case MSJ_REV_ORG:
        return <RevOrg />;
      case MSJ_REV_ORG_CON_OBS:
        return <RevOrgObservaciones />;
      case MSJ_REV_ORG_ATENDIDAS:
        return <RevOrgObsAtendidas />;
      case MSJ_ORG_VALIDADA:
        return <OrgValidada />;
      case MSJ_ORG_INACTIVA:
        return <OrgInactiva />
      default:
        return <MsjDefault />;
    }
  };

  const MsjDefault = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col span={24}>
            <p>
              No se pudo determinar el mensaje a visualizar.
            </p>
          </Col>
        </Row>
      </div>
    )
  };

  const AltaOrg = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
            <h1>Llena tu solicitud de registro como organización</h1>
            <p>
              Captura tus datos y adjunta los documentos que se te solicitan.
            </p>
            <Link to={{ pathname: "/organizacion/registro", state: true }}>
              <Button type="primary">Llenar solicitud</Button>
            </Link>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={8} sm={0} xs={0}>
            <LogoCaptura className="logo" />
          </Col>
        </Row>
      </div>
    );
  };

  const RevOrg = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
            <h1>Tus datos están en revisión</h1>
            <p>
              Se te informará el resultado de la revisión mediante el portal y por correo electrónico.
            </p>
            {ciudadano.id && (<>
              <Link to={{ pathname: "/organizacion/consulta", state: true, consulta: true }}>
                <Button style={{width:200}} type="primary">Consultar solicitud</Button>
              </Link>{'       '}
              <Link to={{ pathname: "/organizacion/modificar", state: true, modificar: true }}>
                <Button type="primary" style={{width:200}}>Modificar solicitud</Button>
              </Link>
              </>
            )}
          </Col>
          <Col xxl={6} xl={6} lg={6} md={8} sm={0} xs={0}>
            <LogoRevision className="logo" />
          </Col>
        </Row>
      </div>
    );
  };

  const RevOrgObservaciones = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
            <h1>Tus datos requieren ajustes</h1>
            <p>
              Realizamos observaciones en tu solicitud, actualiza tus datos para continuar con tu proceso.
            </p>
            <Link to={"/organizacion/observaciones"}>
              <Button style={{ width: 210 }} type="primary">Revisar observaciones</Button>
            </Link>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={8} sm={0} xs={0}>
            <Observaciones className="logo" />
          </Col>
        </Row>
      </div>
    );
  };

  const RevOrgObsAtendidas = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
            <h1>Tus datos corregidos están en revisión</h1>
            <p>
              Se te informará el resultado de la revisión mediante el portal y por correo electrónico.
            </p>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={8} sm={0} xs={0}>
            <LogoRevision className="logo" />
          </Col>
        </Row>
      </div>
    );
  };

  const OrgValidada = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
            <h1>Tu solicitud ha sido validada. Este es tu código de organización:</h1>
            {datosOrg && (
              <p>{datosOrg.codigoOrg}</p>
            )}
          </Col>
          <Col xxl={6} xl={6} lg={6} md={8} sm={0} xs={0}>
            <SolValidada className="logo" />
          </Col>
        </Row>
      </div>
    );
  };

  const OrgInactiva = () => {
    return (
      <div className="home mensaje">
        <Row>
          <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
            <h1>Tu organización ha sido eliminada.</h1>
            <p>
              Lamentamos no poder contar con tu participación en este {datosOrg.nombreProceso}.
            </p>
            <p>
              Esperamos tu presencia en el siguiente Proceso Electoral.
              Recuerda que tu participación es lo más importante en las
              elecciones.
            </p>
            <p>Contamos todas, contamos todos.</p>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={8} sm={0} xs={0}>
            <LogoContamos className="logo" />
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div>
      <Row>
        <Col span={24} style={{textAlign: "center"}}>
          <h2>Este es el avance en tu proceso de validación como organización</h2>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="avanceOrg">
            <Steps current={estadoHomeOrg.fase}>
              <Step description="Alta de la organización" />
              <Step description="Revisión de solicitud / corrección de datos" />
              <Step description="Validación de la organización" />
            </Steps>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <RenderMensaje />
        </Col>
      </Row>
      <Row>
        <Col span={24} className="home mensaje">
          <PregFrecOrg />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LinksOrg />
        </Col>
      </Row>
    </div>
  );
}

export default withRouter(HomeOrg);
